import { Text } from "@mantine/core";
import { DataGridSelectionKeys, DBStatusResult, EntityClientAction, LookupFormAction } from "@mcurros2/microm";
import { PersonalTiendas } from "./PersonalTiendas";

export const ACTAgregarTienda: EntityClientAction = {
    name: 'ACTAgregarTienda',
    label: 'Agregar Tienda',
    title: <Text fw={700}>Agregar Tienda</Text>,
    refreshOnClose: true,
    dontRequireSelection: true,
    showActionInViewMode: true,
    views: ['plti_brwGestionTiendasPersonal'],
    onClick: async ({ entity, modal, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const parent = entity as PersonalTiendas;
  
        await modal.open({
            modalProps: {
                title: <Text fw="700">Agregar Tienda</Text>,
                size: 'xl'
            },
            focusOnClosed: element,
            content: <LookupFormAction
                lookupEntity={entity}
                viewName={entity.def.views.plti_brwGestionTiendasPersonalAgregar.name}
                title="Agregar tienda"
                confirmContent="¿Está seguro de que desea agregar las tiendas seleccionadas?"
                onActionFinished={async () => { if (onClose) await onClose(); }}
                showActions={true}
                onOK={
                    async (keys: DataGridSelectionKeys, abortSignal: AbortSignal): Promise<DBStatusResult> => {
                        if (keys && keys.length > 0) {
                            await parent.API.addData(abortSignal, keys, true);
                        }
                        return { Results: [{ Status: 0, Message: 'OK' }] } as DBStatusResult;
                    }
                }
            />

        });

        return false;
    }
}